import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BASE_PATH } from '../../models/globals';
import Header from './Header';
import Footer from './Footer';
import { useHostnameFlags } from '../../context/HostnameContext';

// Vite encourages this method of obtaining static asset urls: https://vitejs.dev/guide/assets.html
import defaultLogoSrc from '../../assets/buddy_wordmark_white.svg';
import defaultMobileLogoSrc from '../../assets/logo-word.png';
import interplanetaryLogoSrc from '../../assets/interplanetary.png';
import pomiLogoSrc from '../../assets/pomi-logo-w.svg';
import pomiLogoMobileSrc from '../../assets/pomiLogoGrey.png';
import fldeanLogoSrc from '../../assets/fldean-logo.svg';
import gaigLogoSrc from '../../assets/logo-gaig.svg';
import poweredByBuddySrc from '../../assets/powered-by-buddy-grey.png';

const Layout = ({ children, ...props }) => {
	/*
	I don't love using state and useEffect to ensure the logo is dynamic here, but due to the static compile it won't work without it. It was checking in Node to see whether window.location.search included, pomi, and since it doesn't was building with the default only. Worked locally, but not once built. This useState and useEffect fix the issue.
	*/
	const [logoSrc, setLogoSrc] = useState(defaultLogoSrc);
	const { pathname, search } = useLocation();

	const {
		isPomi, isFLDean, isContractCoverage, isInterplanetary,
	} = useHostnameFlags();

	useEffect(() => {
		if (isInterplanetary) {
			setLogoSrc(interplanetaryLogoSrc);
		}
		if (isPomi) {
			setLogoSrc(pomiLogoSrc);
		}
		if (isFLDean) {
			setLogoSrc(fldeanLogoSrc);
		}
		if (isContractCoverage) {
			setLogoSrc(gaigLogoSrc);
		}
	}, []);

	const logoStyles = isFLDean ? { backgroundColor: 'white', padding: '8px', maxWidth: 500 } : { maxWidth: 500 };

	let logoAltLabel = 'Buddy Logo';
	let mobileLogoSrc = defaultMobileLogoSrc;
	let mobileLogoAltLabel = 'Buddy Mobile Logo';

	if (isPomi) {
		logoAltLabel = 'Pomi Logo';
		mobileLogoAltLabel = 'Pomi Mobile Logo';
		mobileLogoSrc = pomiLogoMobileSrc;
	} else if (isFLDean) {
		logoAltLabel = 'FL Dean Logo';
		mobileLogoAltLabel = 'FL Dean Mobile Logo';
		mobileLogoSrc = fldeanLogoSrc;
	} else if (isContractCoverage) {
		logoAltLabel = 'GAIG Logo';
		mobileLogoAltLabel = 'GAIG Mobile Logo';
		mobileLogoSrc = gaigLogoSrc;
	} else if (isInterplanetary) {
		logoAltLabel = 'Interplanetary Insurance Logo';
		mobileLogoAltLabel = 'Interplanetary Insurance Mobile Logo';
		mobileLogoSrc = interplanetaryLogoSrc;
	}

	const isVerifiedEmail = search.toLowerCase('').includes('verified');

	// if we're past authentication and inside the app, just return children, since App will use its own layout which needs to inherit customer props.
	if (pathname.includes(BASE_PATH)) {
		return children;
	}

	return (
		<div className="layout-container" data-testid="layout-container">
			{pathname.includes(BASE_PATH) ? <Header {...props} /> : null}
			<div className="d-flex flex-grow">
				<div className="w-100 bg-lighter-gray d-none d-lg-flex">
					<div className="container mx-auto my-auto">
						<div className="my-5 px-5 mx-auto login-left-panel">
							<img
								src={logoSrc}
								className="w-100 mb-4"
								alt={logoAltLabel}
								style={logoStyles}
							/>
							<h2 className="mb-4">
								{ isVerifiedEmail ? 'Account Verified!' : 'Welcome!'}
							</h2>
							<h6>

								Thank you for using the Insured Portal.
								<br />
								Log in to manage your policy, download documents, and more.
							</h6>
						</div>
					</div>
				</div>
				<div className="container mx-auto my-auto">
					<div className="mt-3 d-lg-none text-center">
						<img
							src={mobileLogoSrc}
							className="w-100"
							alt={mobileLogoAltLabel}
							style={{ maxWidth: 200 }}
						/>
					</div>
					<div className="my-3 my-sm-5">
						{children}
					</div>
					<div className="d-flex justify-content-center py-5">
						<a
							href={process.env.CLIENT_MAIN_WEBSITE_URL}
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={poweredByBuddySrc}
								className="w-100"
								alt="Powered by Buddy"
								style={{ maxWidth: 200 }}
							/>
						</a>
					</div>
				</div>
			</div>
			<div id="footer">
				<Footer />
			</div>
		</div>
	);
};

export default Layout;
